const OptionTypes = {
    Text: 'text',
    Image: 'image',
} as const;

export default OptionTypes;
